import { AxiosInstance } from "axios";
import { ongBaseApi } from "./ong-base-api";
import { OngBaseResponse } from "./ong-base-response";
import {
  SLAByLine,
  SLAByWorker,
  SLAIssuesSummary,
  SLAPeriodPayload,
  SLASummary,
} from "../types/report/sla";

export enum ReportApiUrl {
  slaSummary = "/report/sla/summary",
  slaByWorker = "/report/sla/by-worker",
  slaByScheduleLine = "/report/sla/by-schedule-line",
  slaIssuesSummary = "/report/sla/issues/summary",
}

class ReportApi {
  private _api: AxiosInstance;

  constructor(api: AxiosInstance) {
    this._api = api;
  }

  private _params(payload: SLAPeriodPayload) {
    const params: Record<string, string> = {
      from_date: payload.fromDate,
      to_date: payload.toDate,
    };
    if (payload.clientId) params.client_id = payload.clientId;
    if (payload.agencyId) params.agency_id = payload.agencyId;
    return params;
  }

  async getSummary(
    payload: SLAPeriodPayload,
  ): Promise<OngBaseResponse<SLASummary>> {
    return this._api.get(ReportApiUrl.slaSummary, {
      params: this._params(payload),
    });
  }

  async getByWorker(
    payload: SLAPeriodPayload,
  ): Promise<OngBaseResponse<SLAByWorker>> {
    return this._api.get(ReportApiUrl.slaByWorker, {
      params: this._params(payload),
    });
  }

  async getByScheduleLine(
    payload: SLAPeriodPayload,
  ): Promise<OngBaseResponse<SLAByLine>> {
    return this._api.get(ReportApiUrl.slaByScheduleLine, {
      params: this._params(payload),
    });
  }

  async getIssuesSummary(
    payload: SLAPeriodPayload,
  ): Promise<OngBaseResponse<SLAIssuesSummary>> {
    return this._api.get(ReportApiUrl.slaIssuesSummary, {
      params: this._params(payload),
    });
  }
}

export const reportApi = new ReportApi(ongBaseApi);
